import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event: Event): void {
    const target = event.target as HTMLInputElement
    const form = target.form ?? (this.element as HTMLFormElement)
    form.requestSubmit()
  }
}
